import React from 'react';

export const GlassPageIndicator = ({
  currentPage,
  totalPages,
  className = '',
}) => {
  return (
    <div className={`glass-page-indicator ${className}`}>
      <span className="counter">{currentPage + 1} of {totalPages}</span>
      <div className="dots">
        {[...Array(totalPages)].map((_, index) => (
          <div
            key={index}
            className={`dot ${currentPage === index ? 'active' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};